import styled from "styled-components";
import { PasswordToggle } from "./Login.styles";

export const Container = styled.div`
  width: 100%;
`;

export const StyledInputContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ContainerSenha = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InputSenha = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  input {
    width: 100%;
    padding: 12px 48px 12px 12px;
    margin: 0;
    box-sizing: border-box;
    font-size: 16px;
    border: 1.6px solid #cfd8dc;
    border-radius: 10px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  input:focus {
    border-color: #b79931; /* cor da marca */
    box-shadow: 0 0 0 4px rgba(183, 153, 49, 0.16);
  }
`;

export const IconVisible = styled(PasswordToggle).attrs({ type: "button" })``;

export const ContainerRequisitos = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 13px;
  line-height: 1.6;
  strong { display: block; margin-bottom: 6px; color: #374151; font-size: 13px; font-weight: 600; }
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    display: flex;
    align-items: center;
    padding-inline: 0;
    margin: 0 0 8px 0;
    font-size: 16px;
    color: grey;
  }

  ul {
    padding-left: 18px;
    margin: 0;
  }
`;
